import * as React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide
} from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import { Body1 } from '../../themes/typography';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function RedirectToTicket({ open = false, onClose = () => {}, onClick = () => {} }) {
    return (
        <React.Fragment>
            <Dialog
                open={open}
                keepMounted
                TransitionComponent={Transition}
                aria-describedby="redirect-to-ticket-page"
                sx={dialogStyle}
            >
                <DialogTitle>Let's create tickets?</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <ul className="ticket-creation-notes">
                            <li>
                                <Body1>
                                    Continue by creating tickets for this event to make it live.
                                </Body1>
                            </li>
                            <li>
                                <Body1>
                                    Skip it for now and create tickets later when you are ready.
                                </Body1>
                            </li>
                        </ul>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={dialogActionsStyle}>
                    <Button variant="text" onClick={onClose} sx={dialogActionsMainBtn}>
                        Skip for now
                    </Button>
                    <Button
                        variant="main"
                        onClick={onClick}
                        endIcon={<EastIcon />}
                        sx={dialogActionsMainBtn}
                    >
                        Create Ticket
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

const dialogActionsStyle = {
    padding: '1.25rem 1.5rem 1.5rem 1.5rem',
    gap: '0.5rem'
};

const dialogActionsMainBtn = {
    paddingTop: '6px',
    paddingBottom: '6px',
    fontSize: '1.125rem'
};

const dialogStyle = {
    '& .MuiPaper-root': {
        background: 'linear-gradient(to top left, #0A1528, #1D3A6E)',
        color: '#f5f5f5',
        borderRadius: '1rem',
        border: '1px solid #CCCCCC',
        minWidth: '600px',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
    }
};
